var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildTitle, buildStandardMeta, buildOgMeta, buildOgMetaRefs, buildLink, buildStructuredData, } from '../../types/builders';
import { siteIDs } from '../../adapters/utils';
import adapter from './adapter-challenges-page';
import challengesSchema from './schema-presets/challenges-page';
/**
 Here you can find more details about the implementation
 https://docs.google.com/document/d/16MAdLjujVtzlDrez1JQs8SlI146sgp7KGIq_8XEEGRI/edit#
*/
var IDs = adapter.IDs;
export var CHALLENGES_PAGE = {
    tags: __spreadArrays([
        buildTitle("{{" + IDs.CALCULATED_NAME + "}} | {{" + siteIDs.SITE_NAME + "}}"),
        buildStandardMeta('description', "{{" + IDs.DESCRIPTION_150 + "}}"),
        buildStandardMeta('robots', "{{" + IDs.CALCULATED_ROBOTS + "}}")
    ], buildOgMetaRefs(), [
        buildOgMeta('og:image', "{{" + IDs.CALCULATED_MAIN_IMAGE_URL + "}}"),
        buildOgMeta('og:image:width', "{{" + IDs.IMAGE_WIDTH + "}}"),
        buildOgMeta('og:image:height', "{{" + IDs.IMAGE_HEIGHT + "}}"),
        buildOgMeta('og:site_name', "{{" + siteIDs.SITE_NAME + "}}"),
        buildOgMeta('og:type', 'website'),
        buildOgMeta('og:url', "{{" + IDs.URL + "}}"),
        buildLink('canonical', "{{" + IDs.URL + "}}"),
        buildStructuredData({
            schema: challengesSchema.schema,
            schemaType: challengesSchema.type,
            disabled: [
                "{{" + IDs.SD_DISABLE_SCHEMA + "}}",
                '{{options.disable-pattern-schema}}',
            ],
        }),
    ]),
};
